import { render, staticRenderFns } from "./AdminPolicyCreate.vue?vue&type=template&id=05a8fa82"
import script from "./AdminPolicyCreate.vue?vue&type=script&lang=js"
export * from "./AdminPolicyCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports